import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  sortBy: 'priceAsc',
  selectedFacilities: [],
};

export const FilterServiceSlice = createSlice({
  name: 'filter-services',
  initialState,
  reducers: {
      sortByLowestPriceServices(state, action) {
          state.sortBy = action.payload;
      },
      setSelectedFacilities(state, action) {
          state.selectedFacilities = action.payload;
      },
      clearSetSelectedFacilities(state, action) {
        state.selectedFacilities = [];
    },
  },
});

export const {
  sortByLowestPriceServices,
  setSelectedFacilities,
  clearSetSelectedFacilities
} = FilterServiceSlice.actions;

export default FilterServiceSlice.reducer;